export enum BranchStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}
export const BRANCH_STATUS_LABEL = {
  [BranchStatusEnum.Active]: BranchStatusEnum.Active,
  [BranchStatusEnum.Inactive]: BranchStatusEnum.Inactive,
}
